module.exports = __webpack_public_path__ + "img/icon-qrcode-scan@3x.1bc61861.png";